import React from 'react';

import PropTypes from 'prop-types';

import { Typography, TextField, MenuItem, InputAdornment } from '@mui/material';

import {
    Container,
    LeftColumn,
    ContentWrapper,
    TopicWrapper,
    TopicLeftColumn,
    TopicContent,
    FieldWrapper,
    FieldItem,
    FieldLabel
} from './styles';

export const SectionComponent = ({ section, values, handleChange, errors, submitCount }) => {
    const handleFieldChange = (field, e) => {
        let input = e.target.value;
        const numericOnly = input.replace(/\D/g, '');

        if (field.format === 'number' && field.decimal_places > 0) {
            if (numericOnly === '') {
                handleChange({
                    target: {
                        name: `field_${field.id}`,
                        value: ''
                    }
                });
                return;
            }

            const factor = Math.pow(10, field.decimal_places);
            const formatted = (parseFloat(numericOnly) / factor).toFixed(field.decimal_places).replace('.', ',');

            handleChange({
                target: {
                    name: `field_${field.id}`,
                    value: formatted
                }
            });
        } else {
            handleChange({
                target: {
                    name: `field_${field.id}`,
                    value: input
                }
            });
        }
    };

    return (
        <Container>
            <LeftColumn>
                <Typography variant="h6" fontWeight="bold" style={{ color: '#294732' }}>
                    {section.name}
                </Typography>
            </LeftColumn>

            <ContentWrapper>
                {section.topics.map((topic) => (
                    <TopicWrapper key={topic.id}>
                        <TopicLeftColumn>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {topic.name}
                            </Typography>
                        </TopicLeftColumn>

                        <TopicContent>
                            <FieldWrapper>
                                {topic.fields.map((field) => {
                                    const fieldName = `field_${field.id}`;

                                    return (
                                        <FieldItem key={field.id}>
                                            <FieldLabel>{field.title}:</FieldLabel>

                                            <TextField
                                                fullWidth
                                                variant="standard"
                                                select={field.format === 'list'}
                                                type={field.format === 'number' && field.decimal_places === 0 ? 'number' : 'text'}
                                                name={fieldName}
                                                value={values[fieldName] || ''}
                                                onChange={(e) => handleFieldChange(field, e)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    startAdornment:
                                                        field.position === 'left' &&
                                                        field.unit_of_measurement &&
                                                        field.format !== 'list' ? (
                                                            <InputAdornment position="start">{field.unit_of_measurement}</InputAdornment>
                                                        ) : null,
                                                    endAdornment:
                                                        field.position === 'right' &&
                                                        field.unit_of_measurement &&
                                                        field.format !== 'list' ? (
                                                            <InputAdornment position="end">{field.unit_of_measurement}</InputAdornment>
                                                        ) : null,
                                                    style: {
                                                        backgroundColor: '#ffffff',
                                                        border: 'none',
                                                        borderRadius: 8,
                                                        padding: '8px 12px'
                                                    },
                                                    inputMode: field.format === 'number' ? 'numeric' : 'text'
                                                }}
                                                inputProps={{
                                                    inputMode: field.format === 'number' ? 'numeric' : 'text'
                                                }}
                                                error={submitCount > 0 && Boolean(errors?.[fieldName])}
                                                helperText={submitCount > 0 && errors?.[fieldName] ? errors[fieldName] : ''}
                                            >
                                                {field.format === 'list' &&
                                                    field.list?.map((option, idx) => (
                                                        <MenuItem key={idx} value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                            </TextField>
                                        </FieldItem>
                                    );
                                })}
                            </FieldWrapper>
                        </TopicContent>
                    </TopicWrapper>
                ))}
            </ContentWrapper>
        </Container>
    );
};

SectionComponent.propTypes = {
    section: PropTypes.shape({
        name: PropTypes.string.isRequired,
        topics: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                name: PropTypes.string.isRequired,
                fields: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                        title: PropTypes.string.isRequired,
                        format: PropTypes.oneOf(['number', 'list', 'text']).isRequired,
                        decimal_places: PropTypes.number,
                        unit_of_measurement: PropTypes.string,
                        position: PropTypes.oneOf(['left', 'right']),
                        list: PropTypes.arrayOf(PropTypes.string)
                    })
                ).isRequired
            })
        ).isRequired
    }).isRequired,
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitCount: PropTypes.number
};
